import { Controller } from '@hotwired/stimulus';
import { refreshCsrfToken, submitWithFreshCsrfToken } from '../lib/fresh_csrf';

/**
 * Put on a form (or a wrapper of forms) that guests can submit from an edge-cached page.
 * See lib/fresh_csrf.js for why the baked token fails.
 *
 *   data-controller="fresh-csrf"
 *   data-fresh-csrf-url-value="/users/sign_in.json"
 *   data-action="focusin->fresh-csrf#prefetch submit->fresh-csrf#ensure"
 */
export default class extends Controller {
  static values = { url: String };

  // Start the token request while the visitor is still typing.
  prefetch() {
    refreshCsrfToken(this.urlValue);
  }

  ensure(event) {
    submitWithFreshCsrfToken(event, this.urlValue);
  }
}
